import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({ 
  state: {
      Pengguna:{},
      MaklumatPeribadi: {},



      
      MaklPegSeb2003: {},
      MaklPegGaji: {},
      MaklAnjGaji: {},
      MaklKenaikanPangkat: {},
      MaklGajiKUP: {},
      MaklPentapGaji: {},
      MaklTukarLantik: {},
      paparMaklPegGaji:{},
    sidebar_visibility: true,
  },
  getters: {
    // or could have both getters separated
    logged: state => state.Pengguna.logged,
    token: state => state.Pengguna.ev_id,
    loggedIn : state => state.Pengguna.valid,
    role: state => state.Pengguna.roleId
  },
  mutations: {

    addMaklumatPeribadi(state,obj){
      state.MaklumatPeribadi=obj
    },



    
    addMaklPegSeb2003(state,obj){
      state.MaklPegSeb2003=obj
    },

    addMaklPegGaji(state,obj){
      state.MaklPegGaji=obj
      //state.MaklPegGaji.push(obj)
    },

    addMaklAnjGaji(state,obj){
      state.MaklAnjGaji=obj
      //state.MaklAnjGaji.push(obj)
    },

    addMaklKenaikanPangkat(state,obj){
      state.MaklKenaikanPangkat=obj
    },

    addMaklGajiKUP(state,obj){
      state.MaklGajiKUP=obj
    },

    addMaklPentapGaji(state,obj){
      state.MaklPentapGaji=obj
    },

    addMaklTukarLantik(state,obj){
      state.MaklTukarLantik=obj
    },

    clearAll(state){
      state.MaklPegGaji=[]
      state.MaklPegSeb2003= {}
      state.MaklAnjGaji=[]
      state.MaklumatPeribadi= {}
      state.MaklKenaikanPangkat= {}
      state.MaklGajiKUP= {}
      state.MaklPentapGaji={}
      state.MaklTukarLantik= {}
    },

    clearAnjakan(state){
      state.MaklAnjGaji=[]
    },
    clearMaklPegGaji(state){
      state.MaklPegGaji=[]
    },

    clearMaklTukarLantik(state){
      state.MaklTukarLantik={}
    },


    IndpaparMaklPegGaji(state,obj){
      state.paparMaklPegGaji=obj
    },






    saveSingleUserObj(state, obj)
    {
     localStorage.clear()
      _.forEach(obj, function(value, key) {
         state.Pengguna[key] = value;
         localStorage.setItem(key, value);
     })
     state.Pengguna['valid'] = true;
     localStorage.setItem('valid', true)

     },
     initialiseStore(state) {
       // alert('initialize store')          

       if (localStorage.getItem('icno')) {
         for (let i = 0; i < localStorage.length; i++) {
           let key = localStorage.key(i);
           state.Pengguna[key] = localStorage.getItem(key);
         }
         state.Pengguna['valid'] = true
       }else{
         state.Pengguna = {valid:false}
       }
       // alert('after initialize - Pengguna.icno ',state.Pengguna.icno)
     },
     logout(state) {
       localStorage.clear()
       localStorage.setItem('valid', false)
       if (localStorage.getItem('icno')) {
         for (let i = 0; i < localStorage.length; i++) {
           let key = localStorage.key(i);
           localStorage.setItem(key, null);
         }            
         state.Pengguna={valid:false}
       }else{
         state.Pengguna = {valid:false}
       }

       // alert('Logout - Pengguna.icno ',state.Pengguna.icno)
     }
  
  },
  actions: {
    hasPermission({state}){
      return state.Pengguna.valid
    }
  }
  
})

